module.exports = __webpack_public_path__ + "static/media/ms.19a3151d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ms.png
// module id = 1930
// module chunks = 0